import { render } from "./Home.vue?vue&type=template&id=d9324076&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\ProjectsLaravel\\nft_imw_v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/ts/frontend/views/Home.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d9324076"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d9324076', __exports__)) {
    console.log('reload')
    api.reload('d9324076', __exports__)
  }
  
  module.hot.accept("./Home.vue?vue&type=template&id=d9324076&ts=true", () => {
    console.log('re-render')
    api.rerender('d9324076', render)
  })

}


export default __exports__